import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import request from 'Request'
import { ModalStore } from 'Store'

import Tab from '../components/Tab'
import Header from 'Components/Header'
import { Grid } from 'lese'
import Card from 'Components/Card'
import ModalCard from '../components/ModalCard'
import InfoTabs from '../components/InfoTabs'

import {
  faGripVertical,
  faMobile,
  faBuilding,
  faUser
} from '@fortawesome/free-solid-svg-icons'

export default () => {
  const showModal = ({ isCluster, isOffice, isPatient }) =>
    ModalStore.set(state => ({
      components: [
        ...state.components,
        <ModalCard
          title="App"
          baseUrl="/device/report"
          isOffice={isOffice}
          isPatient={isPatient}
          isCluster={isCluster}
          title={
            isCluster
              ? 'Cluster'
              : isOffice
              ? isPatient
                ? 'Patient'
                : 'Office'
              : 'App'
          }
          icon={
            isCluster
              ? faGripVertical
              : isOffice
              ? isPatient
                ? faUser
                : faBuilding
              : faMobile
          }
        />
      ]
    }))

  return (
    <>
      <Header>Device Report Overview</Header>
      <InfoTabs />
      <Header>Report Tools</Header>
      <Grid columns="1fr 1fr 1fr" rows="1fr 1fr" gap="16px">
        <Card
          title="Cluster"
          onClick={() => showModal({ isCluster: true })}
          icon={faGripVertical}
        >
          <span>
            Create a billing report for app offerings in relation to client
            clusters.
          </span>
        </Card>
        <Card title="App" onClick={showModal} icon={faMobile}>
          <span>
            Create a billing report for app offerings in relation to client
            clusters.
          </span>
        </Card>
        <Card
          title="Office"
          icon={faBuilding}
          onClick={() => showModal({ isOffice: true })}
        >
          <span>
            Create a billing report for app offerings in relation to client
            clusters.
          </span>
        </Card>
        <Card
          title="Patient"
          icon={faUser}
          onClick={() => showModal({ isOffice: true, isPatient: true })}
        >
          <span>
            Create a billing report for app offerings in relation to client
            clusters.
          </span>
        </Card>
      </Grid>
    </>
  )
}
